<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Terem- és eszközfoglalás</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$"><br>
<ng-container>

  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card style="height: 100%">
          <ion-card-header>
            <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Beállítások</span>
              <ion-button (click)="searchM()" style="float:right;" size="small" color="light">
                <ion-icon slot="start" name="search"></ion-icon> Keresés
              </ion-button></ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-grid>
              <ion-row>
                <ion-col>
                 
                    <ion-input fill="outline" labelPlacement="stacked"
                      label="Tárgyév"
                      type="text"
                      placeholder="2023"
                      [(ngModel)]="selectedYearS"
                    ></ion-input>
                  
                </ion-col>
              <ion-col>
                
                  <ion-input *ngIf="sajatIntezmeny" fill="outline" labelPlacement="stacked"
                    label="Intézmény"
                    type="text"
                    placeholder="Válasszon intézményt"
                    [value]="sajatIntezmeny.intezmenyName"
                    readonly
                    style="cursor: default;"
                  ></ion-input>
             
              </ion-col>
            </ion-row><!--ion-row>
              <ion-col>
             <div style="margin-top: 5px;">
                  <ion-button (click)="searchM()">
                    <ion-icon slot="start" name="search"></ion-icon>
                    Keresés
                  </ion-button>
                  <ion-button color="secondary" (click)="resetM()">
                    <ion-icon slot="start" name="refresh"></ion-icon>
                    Visszaállítás
                  </ion-button>
                </div>
              </ion-col>
            </ion-row-->
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card >
          <ion-card-header>
            <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Naptár</span>
              <ion-button (click)="printData()" style="float:right;" size="small" color="light">
                <ion-icon slot="icon-only" name="print-outline"></ion-icon>
              </ion-button>
              </ion-card-title>
          </ion-card-header>

          <ion-card-content>


            <!--a-- href="javascript:void(0);" (click)="printUrl('/print?minimize=1')">nyomtatás</a-->
            <!--a href="javascript:void(0);" (click)="printData()">nyomtatás</a>
  <b>FEJLESZTÉS ALATT, ALPHA VÁLTOZAT</b-->
  <div class="scrollable-table printable">
  <table id="printable">
    <thead>
    <tr>
      <!--th>#</th-->
      <th style="border-right: 2px solid;">{{selectedYear}}</th>
      <!--th *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">{{napok[idx%7]}}</th-->
      <ng-container *ngFor="let c of [].constructor(maxnap+maxoffset); let idx = index">
        <th *ngIf="idx%7==6 || idx%7==5" style="background-color: var(--ion-color-primary);color: var(--ion-color-light); text-transform: none !important;" [innerHTML]="napok[idx%7]">{{napok[idx%7]}}</th>
        <th style="text-transform: none !important;" *ngIf="idx%7<5" [innerHTML]="napok[idx%7]">{{napok[idx%7]}}</th>
      </ng-container>
      
      <!--th *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">{{napok[idx%7]}}</th-->
      <!--th>{{replaceAccentedChars("∑(óra)")}}</th-->
      <!--th><ion-icon name="bed-outline"></ion-icon></th-->

    </tr>
    </thead>
    <tbody *ngIf="napoffset && daysInMonth">
    <ng-container *ngFor="let user of [].constructor(12); let i = index">

    <tr *ngIf="daysInMonth[i]">

      <!--td
        style="text-align: center; font-size: 25px; padding: 0"
        rowspan="3"
      >
        <!--ion-button-- color="primary" (click)="printdiv('printable')">
          <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
        </ion-button>
      </td-->
      <td rowspan="1" style="border-right: 2px solid;">{{honapok[i]}}</td>
      <td rowspan="1" *ngFor="let c of [].constructor(napoffset[i]); let id = index" style="background-color:lightgray;cursor:not-allowed;">
        &nbsp;
      </td>
      <ng-container *ngFor="let c of daysInMonth[i]; let id = index">
        <!--td rowspan="1" style="background-color:lightgray">
          &nbsp;&nbsp;
        </td-->
          <td rowspan="1" style="text-align: center; background: lightblue;cursor:pointer;" *ngIf="c.isWeekend || (c.isHoliday && c.holidayType == 0)" (click)="initModal(c,2)">
            {{("0" + (id+1)).slice(-2)}}
          </td>
          <td rowspan="1" style="text-align: center; background: #E5D9F2;cursor:pointer;" *ngIf="c.isHoliday && c.holidayType == 1" (click)="initModal(c,2)">
            {{("0" + (id+1)).slice(-2)}}
          </td>
          <td rowspan="1" style="text-align: center;background:lightyellow;cursor: pointer;" *ngIf="!c.isWeekend && !c.isHoliday && c.nyilvantartas" (click)="initModal(c)">
            {{("0" + (id+1)).slice(-2)}}
          </td>
          <td rowspan="1" style="text-align: center;cursor: pointer;" *ngIf="!c.isWeekend && !c.isHoliday && !c.nyilvantartas" (click)="initModal(c)">
            {{("0" + (id+1)).slice(-2)}}
          </td>

       
      </ng-container>
      <td rowspan="1" *ngFor="let c of [].constructor(7-napoffset[i]+maxnap-daysInMonth[i].length-1); let id = index" style="color:#ddd;text-align: center;background-color:lightgray;cursor:not-allowed;">
        {{("0" + (id+1)).slice(-2)}}
      </td>
      <!--td rowspan="1" class="rotate1">
        123
      </td-->
    </tr>
    

      </ng-container>
    </tbody>

  </table>
  </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>



<ion-modal class="nagy" (willDismiss)="onWillDismiss($event)">
  <ng-template>

    <ng-container *ngIf="modalData && this.orarendLista">
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="end">
            <ion-button (click)="cancel()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Foglalás - {{modalData.dayDate | date:'YYYY.MM.dd.'}}</ion-title>
          <!--ion-buttons slot="end">
            <ion-button style="background: white;border-radius: 5px;" (click)="confirm()" [strong]="true"
              [disabled]="validateForm()" shape="round" color="primary">Mentés</ion-button>
          </ion-buttons-->
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-card color="danger" *ngIf="modalData.option">
          <ion-card-header color="danger">
            <ion-card-title color="danger"><ion-icon name="warning-outline"></ion-icon> Figyelem!</ion-card-title>
            <ion-card-subtitle color="danger" *ngIf="modalData.option == 2">Ezen a napon tanítási szünet van!</ion-card-subtitle>
            <ion-card-subtitle color="danger" *ngIf="modalData.option == 1">Ezen a napon ünnepnap van!</ion-card-subtitle>
          </ion-card-header>
        </ion-card>

        <div class="scrollable-div1" *ngFor="let item of orarendLista; let i = index">
          <ion-chip [class]="'customchip '+item.class">
            <ion-avatar>
              <img [src]="
              environment.avatars+'/api/?name=' +
              i +
              '&rounded=true&size=50&background=fff'
            " />
            </ion-avatar>
            <ion-label *ngIf="!item.foglalo">[ÜRES]</ion-label>
            <ion-label *ngIf="item.foglalo && !item.elfogado">{{ item.foglalodata.viselt_vez }} {{ item.foglalodata.viselt_ker }}</ion-label>
            <ion-label *ngIf="item.foglalo && item.elfogado && item.elfogadva == '1'">{{ item.foglalodata.viselt_vez }} {{ item.foglalodata.viselt_ker }} (Elfogadta: {{ item.elfogadodata.viselt_vez }} {{ item.elfogadodata.viselt_ker }})</ion-label>
            <ion-label *ngIf="item.foglalo && item.elfogado && item.elfogadva == '0'">{{ item.foglalodata.viselt_vez }} {{ item.foglalodata.viselt_ker }} (Elutasítás indoka: {{ item.indok }})</ion-label>
         
            <!--ion-icon *ngIf="item.foglalodata?.adid && item.elfogado && userMetadata.adid == item.foglalodata.adid" (click)="deleteItemFromLista(i)" name="close-circle"></ion-icon-->
       
          </ion-chip>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-textarea fill="outline" labelPlacement="stacked" [disabled]="!((item.elfogado && item.elfogadva == '0') || (item.elfogado && item.elfogadva != '1') || !item.foglalo)"
                        label="Foglalás indoka"
                        type="text"
                        placeholder=""
                        [(ngModel)]="item.foglalas_indok"
                      ></ion-textarea>
                      
              </ion-col>
            </ion-row><ion-row>
              <ion-col>
                <ion-textarea fill="outline" labelPlacement="stacked" disabled *ngIf="item.elfogado && item.elfogadva == '0'"
                label="Elutasítás indoka"
                type="text"
                placeholder=""
                [(ngModel)]="item.indok"
              ></ion-textarea>
              </ion-col>
             
            </ion-row>
            <ion-row *ngIf="!item.foglalo || item.elfogadva == '0'">
              <ion-col>
                <ion-button (click)="foglalasVeglegesit(item,0,null,i)" size="" color="success">
                  <ion-icon slot="start" name="checkmark-outline"></ion-icon>Küldés
                </ion-button>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="item.foglalo && !item.elfogado && userMetadata.foglalas_engedelyezo == 1">
              <ion-col size="6">
                <ion-input fill="outline" labelPlacement="stacked"
                      label="Indok elutasítás esetén"
                      type="text"
                      placeholder="Indok elutasítás esetén"
                      [(ngModel)]="indok"
                    ></ion-input>
              </ion-col>
              <ion-col>
                <ion-button (click)="foglalasVeglegesit(item,2,1)" size="" color="success">
                  <ion-icon slot="start" name="checkmark-outline"></ion-icon>Elfogad
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button (click)="foglalasVeglegesit(item,2,0)" size="" color="danger">
                  <ion-icon slot="start" name="close-outline"></ion-icon>Elutasít
                </ion-button>
              </ion-col>
              
            </ion-row>
            <ion-row *ngIf="item.foglalodata?.adid && item.elfogado && userMetadata.adid == item.foglalodata.adid">
              <ion-col>
                <ion-col>
                  <ion-button (click)="foglalasVeglegesit(item,3)" size="" color="danger">
                    <ion-icon slot="start" name="close-outline"></ion-icon>Visszavonás
                  </ion-button>
                </ion-col>
              </ion-col>
            </ion-row>
            <hr style="border-bottom: 1px solid">
          </ion-grid>
          
        </div>
        
      
      </ion-content>
    </ng-container>
  </ng-template>
  </ion-modal>


</ion-content>
